import { stringify } from 'qs';
import request from '@/utils/request';

export async function expressPrint(payload) {
    return request(`/iwms-wms/wms/express/print`, {
      method: 'POST',
      body: payload,
    });
  }
